<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91/1.png"
			alt="" />

		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">智慧大田解决方案</div>
		<div class="title-desc">智能监测·智能灌溉</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;产业大脑是一个基于大数据、人工智能和云计算等技术构建的，覆盖全产业链、全要素的智能化决策与协同平台。它不仅是数据的“驾驶舱”，更是产业发展的“智慧中枢”。
			其核心功能可以概括为以下四个层面：
			<h2 style="margin: 5px 0;">一、 产业监测与决策支持</h2>
			<h4 style="margin: 5px 0;">全景洞察：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：汇聚宏观经济、区域产业、产业链、企业运行、市场动态等海量数据，实时呈现产业运行全景图。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：帮助政府和企业看清产业家底、发展趋势和自身定位，告别“盲人摸象”。<br />
			<h4 style="margin: 5px 0;">智能研判与预警：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：利用AI模型进行产业链分析、风险预测（如供应链中断风险、市场过热风险）和景气指数研判。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：实现从“事后补救”到“事前预警”和“事中干预”的转变，为科学决策提供依据。<br />

			<h2 style="margin: 5px 0;">二、 资源优化与要素配置</h2>
			<h4 style="margin: 5px 0;">供应链协同优化：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：打通产业链上下游数据，实现需求精准预测、产能智能调度和供应链可视化，促进“以销定产”。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：降低库存成本，提高资源利用效率，增强产业链韧性。<br />
			<h4 style="margin: 5px 0;">精准服务匹配：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：智能匹配技术、资金、人才、土地等要素需求。例如，为企业精准推送扶持政策、对接金融机构、匹配技术专家。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：解决企业“找钱难、找人难、创新难”等问题，优化营商环境。<br />

			<h2 style="margin: 5px 0;">三、 产业协同与公共服务</h2>
			<h4 style="margin: 5px 0;">跨域协同制造：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：在区域内或跨区域组织闲置产能，实现订单共享、协同生产，提升产业集群的整体接单和制造能力。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：破解中小企业“有订单没产能，有产能没订单”的困境。<br />
			<h4 style="margin: 5px 0;">共性技术赋能：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：将行业领先的算法、模型、软件（如CAD、CAE）等作为公共服务开放给企业，特别是中小企业，降低其数字化转型门槛。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：加速产业集群的整体技术升级。<br />

			<h2 style="margin: 5px 0;">四、 可持续发展与未来布局</h2>
			<h4 style="margin: 5px 0;">碳足迹追踪与管理：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：监测和核算全产业链的碳排放，帮助企业应对国际绿色贸易壁垒，实现绿色低碳发展。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：提升产业的可持续发展能力和国际竞争力。<br />
			<h4 style="margin: 5px 0;">未来赛道发现：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：通过分析全球专利、科研论文和投融资数据，识别和评估新兴技术及未来产业的发展机会。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：为区域产业布局和创新方向提供前瞻性指引，抢占未来发展制高点。<br /><br />
			如果说智慧农业/养殖系统是赋能单个农场或企业的“战术大脑”，那么产业大脑就是服务于整个区域或行业的“战略大脑”。它实现了从 “看清全局” 到 “智能分析” ，再到 “精准配置” 和 “协同引导”
			的飞跃，最终目标是提升整个产业的核心竞争力、抗风险能力和可持续发展能力。


		</div>
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">"产业大脑" 延链、补链</div>
		<img style="width: 60%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91/3.png"
			alt="" />
			<img style="width: 50%;"
				src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91/2.png"
				alt="" />
		<!-- <video style="width: 70%;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/%E5%8D%83%E5%B9%BF%E9%81%A5%E6%84%9F%2BAI.mp4" controls></video> -->
		<!-- <img style="width: 80%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1.png"
			alt="" /> -->
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 80%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>